<div class='mt-message'>
  <div [ngClass]="messageContainerClasses">
    <div class='mt-message-margin' *ngIf="isUserSentMessage"></div>
    <div class='mt-non-user-icon' *ngIf="!isUserSentMessage"></div>
    <div class='mt-message-anchor' *ngIf="!isUserSentMessage">
      <mitter-incoming-message-anchor></mitter-incoming-message-anchor>
    </div>

    <div class='mt-message-area'>
      <!-- <div class='mt-message-screenname'> screenName </div> -->
      <div class='mt-message-payload'>
        <mitter-message-payload
          [message]="message"
          [galleryImages]="galleryImages"
          [galleryOptions]="galleryOptions">
        </mitter-message-payload>
      </div>
      <div class='mt-metadata-container'>
        <span> {{timestamp}} </span>
        <mitter-receipt-icon
          [message]="message"
          [isUserSentMessage]="isUserSentMessage">
        </mitter-receipt-icon>
      </div>
      <div *ngIf="isFailed" class='failed' (click)="resendMessage()">
        <div class='icon'>
          <mitter-alert-icon></mitter-alert-icon>
        </div>
        <div class='text'>Failed. Click to retry.</div>
      </div>
    </div>

    <div class='mt-message-anchor' *ngIf="isUserSentMessage">
      <mitter-outgoing-message-anchor></mitter-outgoing-message-anchor>
    </div>
    <div class='mt-user-icon' *ngIf="isUserSentMessage"></div>
    <div class='mt-message-margin' *ngIf="!isUserSentMessage"></div>
  </div>
</div>
